import { render, staticRenderFns } from "./CostTransactionMatchingForm.vue?vue&type=template&id=0156c035&scoped=true&"
import script from "./CostTransactionMatchingForm.vue?vue&type=script&lang=js&"
export * from "./CostTransactionMatchingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0156c035",
  null
  
)

export default component.exports